import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subscription, of } from 'rxjs';

import { AnswerTypeComponent } from '../answer-type.component';
import { FormStore } from '../../common/form.store';
import { KeyValue } from '@angular/common';

@Component({
    selector: 'answer-multi-select',
    templateUrl: './answer-multi-select.component.html',
    standalone: false
})
export class AnswerMultiSelectComponent extends AnswerTypeComponent implements OnInit, OnDestroy {

  private subs = new Subscription();
  public optionsObs: Observable<KeyValue<string, string>[]> = of([]);

  ngOnInit() {
    super.ngOnInit();
    this.optionsObs = of([...this.inputContent.inputContentDatas]);

    const sub = FormStore.reset$.subscribe(() => {
      setTimeout(() => {
        (this.formControlObj as FormControl).patchValue('');
      });
    });
    this.subs.add(sub);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
